import { render, staticRenderFns } from "./Ureportable.vue?vue&type=template&id=13af935a"
import script from "./Ureportable.vue?vue&type=script&lang=js"
export * from "./Ureportable.vue?vue&type=script&lang=js"
import style0 from "./Ureportable.vue?vue&type=style&index=0&id=13af935a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports